import React, { useCallback } from 'react';
import IntlCurrency from 'react-intl-currency-input';
import { InputMoneyProps } from '../../interfaces/InputMoney.interface';
import { Container, Label, InputContainer, SubLabelText, ComponentTooltip, MessageTooltipText, Error } from './styles';

const currencyConfig = {
  locale: 'pt-BR',
  formats: {
    number: {
      BRL: {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    }
  }
};

const InputMoney: React.FC<InputMoneyProps> = ({
  config = currencyConfig,
  error = {},
  id,
  isDisabled,
  label,
  max,
  min,
  name,
  onBlur,
  onChange,
  placeholder,
  subLabel,
  tooltip,
  type,
  value,
  inputModeProp,
  ...rest
}: InputMoneyProps) => {
  return (
    <Container>
      <Label htmlFor={name}> {label} </Label>

      {!!subLabel && (
        <SubLabelText>
          {subLabel}
          {!!tooltip && (
            <ComponentTooltip>
              {tooltip.icon}
              <MessageTooltipText>{tooltip.message}</MessageTooltipText>
            </ComponentTooltip>
          )}
        </SubLabelText>
      )}

      <InputContainer>
        {!!error[name] && <Error title={error[name]}>{error[name]}</Error>}
        <IntlCurrency
          id={id}
          name={name}
          currency="BRL"
          value={value}
          config={config}
          onChange={onChange}
          onBlur={onBlur}
          max={max}
          type={type}
          placeholder={placeholder}
          disabled={isDisabled}
          inputMode={inputModeProp}
          {...rest}
        />
      </InputContainer>
    </Container>
  );
};

export default InputMoney;
